import {
  ChangeDetectorRef,
  Directive,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewContainerRef
} from '@angular/core';
import {ScreenDetectorService} from '../service/screen-detector.service';
import {ScreenDetectorAnswer} from "../@absract/@interface/IConfig.interface";
import {Subject} from "rxjs";

@Directive(
    {
      selector: '[ifScreenTypeNot]',
    }
)
export class IfScreenTypeNotDirective implements OnDestroy, OnInit {

  /**
   * */
  @Input() public ifScreenTypeNot!: string | any[];

  /**
   * */
  @Input('mzDebounceTime') public mzDebounceTime? = 250;

  /**
   * */
  @Output('mzScreenChange') public mzScreenChange: EventEmitter<ScreenDetectorAnswer> = new EventEmitter<ScreenDetectorAnswer>();

  /**
   * */
  private nInvokedCounter = 0;

  /**
   * */
  private alive$: Subject<void> = new Subject();

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private cdRef: ChangeDetectorRef,
    private screenDetector: ScreenDetectorService
  ) {
  }

  ngOnInit() {
      this.screenDetector.getSubscription(
        this.mzDebounceTime,
        this.alive$,
        true
      )
      .subscribe(
          screen => {
            this.check(screen.type);
            this.mzScreenChange.emit(screen);
            this.cdRef.markForCheck();
          }
      );
  }

  ngOnDestroy() {
    this.alive$.next();
    this.alive$.unsubscribe();
  }

  check(screenType: string) {
    const screenTypes = (Array.isArray(this.ifScreenTypeNot)) ? this.ifScreenTypeNot : [this.ifScreenTypeNot];
    this.performCondition(screenTypes.findIndex((item) => item === screenType) === -1);
  }

  performCondition(condition: boolean) {
    if (condition) {
      if (this.nInvokedCounter > 0) this.viewContainer.clear();
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.nInvokedCounter++;
    } else {
      this.viewContainer.clear();
    }
  }
}
